import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import UserNav from "../../components/UserNav/UserNav";
import Sidebar from "../../components/Sidebar/Sidebar";
import Calendar from "../../assets/assets/calendar_today-24px.svg";
import Spinner from "react-spinner-material";
import Rodal from "rodal";
import "rodal/lib/rodal.css";
import UserInfo from "../TestPage/UserInfo";
import Modal from "./Modal";
import { PropTypes } from "prop-types";
import MigrationCalendar from "../Nip/Migration/Calendar";
import Review from "../Nip/Migration/Review";
import Slots from "../Nip/Migration/Slots";
import { assignValues, confirmSection, handleCalendar, handleSelection, mapDispatchToProps } from "../Nip/Migration/functions";


const DemoPage = (props) => {
  const {
    getSlots,
    isGettingDemoSlots,
    DemoSlots,
    isBookingSlot,
    bookingSlotSuccess,
    chooseSlot,
    clearState,
    getMonths,
    demoMonths,
    getDays,
    demoDays,
    isGettingDemoDays,
    isGettingDemoMonths,
  } = props;

  const history = useHistory();

  const appId = props.location.state && props.location.state.id;
  const type = props.location.state && props.location.state.type;

  const [handledSuccess, setHandledSuccess] = useState(false);
  const [state, setState] = useState({
    start_time: "",
    end_time: "",
    slot: "",
    month: "",
    date: "",
    active: false,
    index: "",
    show: false,
  });

  const [modal, setModal] = useState({
    visible: false,
  });

  useEffect(
    () => {
      clearState();
      getMonths();
    },
    // eslint-disable-next-line
    [clearState, getMonths]
  );

  const cancel = () => {
    setState({
      ...state,
      show: false,
    });
  };

  const hide = () => {
  setModal({ visible: false });
  setHandledSuccess(false);
  setTimeout(() => {
    history.push({ pathname: "/dashboard" });
  }, 300); 
};

  const found =
    demoDays && demoDays.some((el) => el.day === Number(state.date));

  const handleChange2 = handleCalendar(
    setState,
    state,
    getDays,
    found,
    getSlots,
    "pos"
  );

  const handleChange = handleSelection(setState, state, getSlots, "pos");

  const btnValue = (index, start, end, slot) => {
    setState({
      ...state,
      active: true,
      index: index,
      start_time: start,
      slot: slot,
      end_time: end,
    });
  };


  const bookSlot = () => assignValues(appId, state, type, chooseSlot)();

  const openConfirm = confirmSection(state, setState);


  useEffect(
    () => {
     if (bookingSlotSuccess && !handledSuccess) {
        setModal({ ...modal, visible: true });
         setHandledSuccess(true);
      }
    },
    // eslint-disable-next-line
    [bookingSlotSuccess, handledSuccess]
  );

  const disableButton =
    state.start_time === "" ||
    state.date === "" ||
    state.end_time === "" ||
    state.month === "";

  return (
    <div className="container">
      <UserNav />
      <Sidebar />

      <div className="container-body2">
        <UserInfo />
      </div>

      <div className="container-body7">
        <div className="demo-line">
          <div className="demo-header">
            <div className="image">
              <img src={Calendar} alt="icon" />
            </div>
            <h3>Schedule a Demo</h3>
          </div>
          {state.show ? (
            <Review
              type={type}
              state={state}
              disableButton={disableButton}
              cancel={cancel}
              isBookingSlot={isBookingSlot}
              bookSlot={bookSlot}
              text={"Demo"}
            />
          ) : (
              <div>
                {isGettingDemoMonths ? (
                  <div className="demo-calendar">
                    <Spinner
                      size={120}
                      color={"#047558"}
                      spinnerwidth={5}
                      visible={true}
                    />
                  </div>
                ) : (
                    <MigrationCalendar
                      state={state}
                      migrationMonths={demoMonths}
                      migrationDays={demoDays}
                      isGettingMigrationDays={isGettingDemoDays}
                      handleChange2={handleChange2}
                      found={found}
                      handleChange={handleChange}
                    />
                  )}

                {isGettingDemoSlots ? (
                  <div className="center-spinner2">
                    <Spinner
                      size={120}
                      color={"#047558"}
                      spinnerwidth={5}
                      visible={true}
                    />
                  </div>
                ) : (
                    <Slots
                      state={state}
                      migrationDays={demoDays}
                      migrationSlots={DemoSlots}
                      btnValue={btnValue}
                      found={found}
                    />
                  )}
                {DemoSlots && DemoSlots.length > 0 ? (
                  <div className="proceed-btn-div">
                    <button
                      className="proceed-btn"
                      disabled={disableButton}
                      onClick={openConfirm}
                    >
                      Book Slot
                  </button>
                  </div>
                ) : (
                    ""
                  )}
              </div>
            )}
          <Rodal
            width={550}
            height={500}
            visible={modal.visible}
          >
            <Modal click={hide} />
          </Rodal>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = stateToProps();
propTypes();

export default connect(mapStateToProps, mapDispatchToProps)(DemoPage);

function stateToProps() {
  return (state) => {
    return {
      isGettingDemoSlots: state.demo.isGettingDemoSlots,
      DemoSlots: state.demo.DemoSlots,
      getDemoSlotsSuccess: state.demo.getDemoSlotsSuccess,
      isGettingDemoMonths: state.demo.isGettingDemoMonths,
      demoMonths: state.demo.demoMonths,
      getDemoMonthsSuccess: state.demo.getDemoMonthsSuccess,
      isGettingDemoDays: state.demo.isGettingDemoDays,
      demoDays: state.demo.demoDays,
      getDemoDaysSuccess: state.demo.getDemoDaysSuccess,
      isBookingSlot: state.demo.isBookingSlot,
      bookingSlotSuccess: state.demo.bookingSlotSuccess,
    };
  };
}

function propTypes() {
  DemoPage.propTypes = {
    DemoSlots: PropTypes.array,
    bookingSlotSuccess: PropTypes.bool,
    chooseSlot: PropTypes.func,
    clearState: PropTypes.func,
    demoDays: PropTypes.array,
    demoMonths: PropTypes.array,
    getDays: PropTypes.func,
    getMonths: PropTypes.func,
    getSlots: PropTypes.func,
    isBookingSlot: PropTypes.bool,
    isGettingDemoDays: PropTypes.bool,
    isGettingDemoMonths: PropTypes.bool,
    isGettingDemoSlots: PropTypes.bool,
    location: PropTypes.shape({
      state: PropTypes.shape({
        id: PropTypes.number,
        type: PropTypes.string,
      }),
    }),
  };
}
